import React, { useState } from "react";
import { Button, Steps, Select } from "antd";
import { toast } from "react-toastify";
import Loader from "./Loader/Loader";
import { DownloadExcelFile, slugify } from "./TenantUtils";
import FieldHeading from "./FieldHeading/FieldHeading";
import UploadComponent from "./CustomUpload";
import Services from "../../../Services/dataService";

const OutletsSteps = ({ handler }) => {
	const token = {
		colorTextTertiary: "rgba(0, 0, 0, 0.45)",
		colorFillAlter: "rgba(0, 0, 0, 0.02)",
		colorBorder: "#d9d9d9"
	};

	const [current, setCurrent] = useState(0);
	const [data, setData] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [inValids, setInValids] = useState({
		inValids: {},
		blanks: {},
		notUnique: {}
	});
	const [showInvalids, setShowInvalids] = useState(false);
	const [summary, setSummary] = useState({});
	let headings = [];
	if (Object.keys(data).length > 0) {
		headings = data.reduce((acc, cur) => {
			let keys = Object.keys(cur);
			for (let elem of keys) {
				if (!acc.includes(elem)) {
					acc.push(elem);
				}
			}
			return acc;
		}, []);
	}

	const [radioObj, setRadioObj] = useState({});
	let coreLabels = [
		{ label: "Store Code", value: "code", validationType: "string" },
		{ label: "Store Name", value: "name", validationType: "string" },
		{ label: "Store Latitude", value: "lat", validationType: "number" },
		{ label: "Store Longitude", value: "long", validationType: "number" },
		{ label: "Store Sales", value: "sales", validationType: "number" }
	];

	let [jsonToOutletConf, setJsonToOutletConf] = useState({});
	let markerTitle = ["name"];
	const options = headings?.map(heading => {
		return { label: heading, value: heading };
	});

	const onRadioChange = (e, value) => {
		let copy = { ...radioObj };
		let val = e;
		for (let c in copy) {
			if (e === copy[c]) {
				val = "";
				toast.error("2 Fields Cant have same value");
			}
		}
		if (markerTitle.includes(value)) {
			copy[value] = val;
			setRadioObj(copy);
			return;
		}

		copy[value] = val;
		setRadioObj(copy);
	};

	const setFieldRows = fieldRow => {
		return (
			<table className="table table-bordered">
				<thead>
					<tr>
						<td></td>
						<td>Map Relevent Column From The File</td>
					</tr>
				</thead>
				<tbody>
					{fieldRow.map(row => {
						return (
							<tr>
								<td>{row.label}</td>
								<td>
									<Select
										size="large"
										style={{ width: "100%" }}
										options={options}
										value={radioObj[row.value]}
										showSearch
										placeholder={`Map ${row.label}`}
										onChange={e => onRadioChange(e, row.value)}
									/>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	const dumpClientShops = async () => {
		setIsLoading(true);
		const res = await Services.dumpShops({
			config: {
				dataFields: {
					core: jsonToOutletConf.data,
					additional: jsonToOutletConf.additionalFields
				}
			},
			data
		});
		if (res.data.success) {
			toast.success(res.data.message);
			setIsLoading(false);
		} else {
			toast.error(res.data.message);
			setIsLoading(false);
		}
	};

	const validateFile = () => {
		let uniqueCode = [];
		let notUnique = {};
		let notValids = {};
		let blanks = {};
		let only = ["lat", "long", "sales"];
		for (let ind = 0; ind < data.length; ind++) {
			let row = data[ind];
			for (let dot of jsonToOutletConf["data"]) {
				const { value, field } = dot;
				if (value) {
					if (!row[value]) {
						if (!blanks[value]) {
							blanks[value] = {
								arr: [ind + 2],
								count: 1,
								value: [
									{
										name: row[value],
										type: typeof row[value]
									}
								]
							};
						} else {
							blanks[value]["arr"].push(ind + 2);
							blanks[value]["count"] += 1;
							blanks[value]["value"].push({
								name: row[value],
								type: typeof row[value]
							});
						}
					} else {
						if (only.includes(field)) {
							if (isNaN(parseFloat(row[value]))) {
								if (!notValids[value]) {
									notValids[value] = {
										arr: [ind + 2],
										count: 1,
										value: [
											{
												name: row[value],
												type: typeof row[value]
											}
										]
									};
								} else {
									notValids[value]["arr"].push(ind + 2);
									notValids[value]["count"] += 1;
									notValids[value]["value"].push({
										name: row[value],
										type: typeof row[value]
									});
								}
							}
						}
						if (field === "code") {
							if (uniqueCode.includes(row[value])) {
								if (!notUnique[value]) {
									notUnique[value] = {
										arr: [ind + 2],
										count: 1,
										value: [
											{
												name: row[value],
												type: typeof row[value]
											}
										]
									};
								} else {
									notUnique[value]["arr"].push(ind + 2);
									notUnique[value]["count"] += 1;
									notUnique[value]["value"].push({
										name: row[value],
										type: typeof row[value]
									});
								}
							} else {
								uniqueCode.push(row[value]);
							}
						}
					}
				}
			}
		}

		setInValids({ inValids: notValids, blanks, notUnique });
		if (
			Object.keys(blanks).length === 0 &&
			Object.keys(notValids).length === 0 &&
			Object.keys(notUnique).length === 0
		) {
			dumpClientShops();
		} else {
			setShowInvalids(true);
			toast.error("File Is Not Valid");
		}
	};

	const displayInvalids = () => {
		const tableData = [];
		const reportLog = [];
		const rowNumbers = [];

		for (const key of Object.keys(inValids)) {
			for (const colName of Object.keys(inValids[key])) {
				const arr = inValids[key][colName]["arr"];

				for (let index = 0; index < arr.length; index++) {
					const item = arr[index];
					const rowKey = `${colName}`;
					const content = `${item}`;
					const type = key;
					if (!rowNumbers.includes(data[parseInt(content) - 2])) {
						reportLog.push(data[parseInt(content) - 2]);
						rowNumbers.push(data[parseInt(content) - 2]);
					}
					tableData.push({
						rowKey: rowKey,
						column: colName,
						key: rowKey,
						content: content,
						type
					});
				}
			}
		}
		return (
			<>
				<>
					<h3>There are some invalid / blank data in the file, Kindly recifity the file and upload again</h3>
					<div
						style={{
							display: "flex",
							justifyContent: "end"
						}}
					>
						<Button
							onClick={() => {
								DownloadExcelFile(reportLog, "Invalid File");
								DownloadExcelFile(tableData, "Invalid Information");
							}}
						>
							Download Log Report
						</Button>
					</div>
					{/* <Table
          locale={{
            emptyText: <h1>Valid File</h1>,
          }}
          columns={columns}
          dataSource={data}
          pagination={{ pageSize: 10 }}
        /> */}
				</>

				{/* <div
					style={{
						display: "flex",
						justifyContent: "end"
					}}
				>
					<Button onClick={() => DownloadExcelFile(data, "Invalid File")}>Download</Button>
				</div>
				<Table
					locale={{
						emptyText: <h1>Valid File</h1>
					}}
					columns={columns}
					dataSource={tableData}
					pagination={{ pageSize: 10 }}
				/> */}
			</>
		);
	};
	const steps = [
		{
			title: "Upload File",
			content: (
				<div style={{ padding: "10px" }}>
					<UploadComponent getData={setData} />
					{/* <UploadFile getData={setData} /> */}
				</div>
			)
		},
		{
			title: "Column Mapping",
			content: <div style={{ padding: "10px" }}>{setFieldRows(coreLabels)}</div>
		},
		{
			title: "Summary",
			content: (
				<div style={{ padding: "10px" }}>
					<h2>Summary</h2>
					<ul>
						{Object.keys(summary).map(m => {
							return (
								<li>
									<FieldHeading key={m} field={radioObj[m]} />
								</li>
							);
						})}
					</ul>
				</div>
			)
		},
		{
			title: "Import Shops",
			content: (
				<div style={{ padding: "10px" }}>
					<Button onClick={() => validateFile()}>{isLoading ? <Loader /> : "Import Shops"}</Button>
					{showInvalids && displayInvalids()}
				</div>
			)
		}
	];
	const next = () => {
		if (current === 1) {
			let coreKeys = [];
			let comp = [
				{ label: "Store Code", value: "code" },
				{ label: "Store Name", value: "name" },
				{ label: "Store Latitude", value: "lat" },
				{ label: "Store Longitude", value: "long" }
			];
			for (let co of comp) {
				if (!radioObj[co["value"]]) {
					toast.error(`${co["label"]} Can't Be Empty`);
					return;
				}
			}
			for (let elem in radioObj) {
				coreKeys.push(radioObj[elem]);
			}
			for (let head of headings) {
				if (!coreKeys.includes(head)) {
					radioObj[slugify(head)] = head;
				}
			}
			setSummary(radioObj);
		}
		if (current === 2) {
			let jsonToOutletConf = {
				data: [],
				additionalFields: []
			};

			for (let elem of coreLabels) {
				const { value, validationType } = elem;
				jsonToOutletConf["data"] = [
					...jsonToOutletConf["data"],
					{
						field: value,
						value: radioObj[elem.value],
						type: "custom",
						validationType
					}
				];
			}
			let coreKeys = [];
			for (let elem of coreLabels) {
				coreKeys.push(elem["value"]);
			}
			for (let head in radioObj) {
				if (!coreKeys.includes(head)) {
					jsonToOutletConf["additionalFields"].push({
						field: head,
						value: radioObj[head],
						type: "custom"
					});
				}
			}
			setJsonToOutletConf(jsonToOutletConf);
		}

		setCurrent(current + 1);
	};

	const prev = () => {
		setCurrent(current - 1);
	};
	const contentStyle = {
		width: "100%",
		// lineHeight: "260px",
		// textAlign: "center",

		color: token.colorTextTertiary,
		backgroundColor: token.colorFillAlter,
		borderRadius: token.borderRadiusLG,
		border: `1px dashed ${token.colorBorder}`,
		marginTop: 16
	};
	const done = () => {
		handler();
	};

	return (
		<>
			<Steps current={current} items={steps} />
			<div style={contentStyle}>{steps[current].content}</div>
			<div
				style={{
					marginTop: 24
				}}
			>
				{current === steps.length - 1 && (
					<Button type="primary" onClick={() => done()}>
						Done
					</Button>
				)}
				{current > 0 && (
					<Button
						style={{
							margin: "0 8px"
						}}
						onClick={() => prev()}
					>
						Previous
					</Button>
				)}
				{current < steps.length - 1 && (
					<Button type="primary" onClick={() => next()}>
						Next
					</Button>
				)}
			</div>
		</>
	);
};
export default OutletsSteps;
